import { AxiosResponse } from 'axios';
import LoginService from 'pages/login/login.service';
import { axiosRequest } from '../../axios/axios.config';
import {
    DadosEstabelecimento,
    PessoaSimplesTO,
    TDadosPedido,
} from './comprovante-nota-fiscal-outros.model';

const ComprovanteNFOutrosService = () => {
    const path = '/flow';
    const pessoa = '/pessoa';
    const loginService = LoginService();

    return {
        getDadosPessoa(): Promise<AxiosResponse<DadosEstabelecimento>> {
            return axiosRequest.get(`${path}/dadospessoa`, { headers: loginService.getHeaders() });
        },
        getDadosPedido(numeroPedido: string): Promise<AxiosResponse<TDadosPedido>> {
            return axiosRequest.get(`${path}/dadospedido/${numeroPedido}`, {
                headers: loginService.getHeaders(),
            });
        },
        getPessoaSimples(cpfCnpj: string): Promise<AxiosResponse<PessoaSimplesTO>> {
            return axiosRequest.get(`${pessoa}/simples/${cpfCnpj}`, {
                headers: loginService.getHeaders(),
            });
        },
    };
};

export default ComprovanteNFOutrosService;
